<ng-template #noItems>No notes added.</ng-template>

<div *ngIf="items?.length; else noItems">
  <div *ngFor="let item of items; last as last" class="itm">
    <strong>{{ item?.note }}</strong>
    <small>{{ item?.createdBy }} &mdash; {{ item?.created | timezone | date:'short' }}</small>
  </div>
</div>